export default __webpack_public_path__ + "static/media/ye.b3238a84.jpg";